import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { criptografarDado } from "../../helpers";
import { ListaDeProcessoSeletivo } from "../../interfaces/processoSeletivo";
import { verificarToken } from "../../middlewares/Token";
import { dadosCandidato } from "../../services/bancoTalentos";
import { inscreverProcessoSeletivo, listarProcessoPorId } from "../../services/processoSeletivo";
import { Button } from "../styles";
import DivSituacao from "../DivSituacao";
import LogoEmpresa from "../../assets/img/empresa.png";
import "./modalDetalhesVaga.css";

function ModalDetalhesVagas() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    let idCandidato = localStorage.getItem("idCandidato")

    const { idVaga } = useParams()
    const [processando, setProcessando] = useState(false)
    const [listaDeProcessoSeletivo, setListaDeProcessoSeletivo] = useState<ListaDeProcessoSeletivo | null>(null)
    const [situacaoCandidato, setSituacaoCandidato] = useState("")

    const dadosInscricao = listaDeProcessoSeletivo?.processoInscritos.find(
        (inscrito) => inscrito.idCandidato.toString() === idCandidato?.toString()
    )

    const [copiado, setCopiado] = useState(false);

    const fecharModal = () => {
        if (pathname.includes("/processos-inscritos")) {
            navigate("/processos-inscritos");
        } else {
            navigate("/vagas");
        }
    }

    const inscreverProcesso = async (idProcessoSeletivo: number) => {
        setProcessando(true)
        verificarToken(`vagas/${criptografarDado(idProcessoSeletivo.toString())}`)
        if (situacaoCandidato === "Incompleto") {
            toast.warn("É necessário que pelo menos a coluna sobreMim, dataNascimento, avatar, endereço e avaliacaoDisc do candidato esteja preenchidos.")
        }
        try {
            const idProcessoSeletivoCript = criptografarDado(idProcessoSeletivo.toString())
            await inscreverProcessoSeletivo(idProcessoSeletivoCript)
            setProcessando(false)
            listarProcesso()
            toast.success("Candidato inscrito com sucesso.")
        } catch (error: any) {
            if (error.status === 409) {
                toast.error('Candidato já inscrito no processo seletivo.')
            }
        } finally {
            setProcessando(false)
        }
    }

    const listarProcesso = async () => {
        setProcessando(true)
        try {
            if (idVaga) {
                const resposta = await toast.promise(
                    listarProcessoPorId(encodeURIComponent(idVaga.toString())),
                    {
                        pending: 'Processando a sua Solicitação. Por favor, aguarde!',
                        error: 'Erro ao listar dados do processo seletivo.'
                    }
                )
                setListaDeProcessoSeletivo(resposta.data)
            }
        } catch {
            toast.error("Ocorreu um Erro ao listar os Dados da Vaga.")
        } finally {
            setProcessando(false)
        }
    }

    const handleCopiar = (id?: number) => {
        if (id) {
            let idEncoded = encodeURIComponent(id.toString())
            let idCriptografado = criptografarDado(idEncoded)
            const url = `${window.location.origin}/vagas/${idCriptografado}`;
            navigator.clipboard.writeText(url).then(() => {
                setCopiado(true);
                setTimeout(() => setCopiado(false), 3000);
            });
        }
    };

    useEffect(() => {
        const listarDadosCandidato = async () => {
            try {
                const resposta = await dadosCandidato()
                setSituacaoCandidato(resposta.data.situacaoCadastral)
            } catch {
                setProcessando(false)
            }
        }
        listarDadosCandidato()
    }, [])

    useEffect(() => {
        listarProcesso()
    }, [idVaga])

    const SeInscrito = listaDeProcessoSeletivo?.processoInscritos.some(
        (inscrito) => inscrito.idCandidato.toString() === idCandidato?.toString()
    );

    return (
        <div className='fundoModal'>
            <section className="containerModalCentro">
                <section className="cabecalho">
                    <div className="informacoes-vaga">
                        <div className="logo-img">
                            <img
                                src={listaDeProcessoSeletivo?.cadastro.avatar ? listaDeProcessoSeletivo.cadastro.avatar : LogoEmpresa}
                                alt=""
                                className="logo-empresa"
                            />
                        </div>
                        <div>
                            <h1 className="titulo-vaga">{listaDeProcessoSeletivo?.titulo || "Titulo não disponivel"}</h1>
                            <p className="descricao">{listaDeProcessoSeletivo?.cadastro.nomeFantasia || "Nome da empresa não disponivel"}</p>
                            <p className="descricao">{listaDeProcessoSeletivo?.localTrabalhoCidade || "Cidade não disponivel"} - {listaDeProcessoSeletivo?.localTrabalhoEstado || "Estado não disponivel"}</p>
                        </div>
                    </div>
                    <div className="tags-vaga">
                        <span className="tag">{listaDeProcessoSeletivo?.modalidadeTrabalho || ""}</span>
                        <span className="tag">R$ {listaDeProcessoSeletivo?.salario || ""}</span>
                        <span className="tag">{listaDeProcessoSeletivo?.regimeContratacao || ""}</span>
                        <span className="tag">{listaDeProcessoSeletivo?.formacaoAcademica || ""}</span>
                    </div>
                    {listaDeProcessoSeletivo && (
                        <>
                            {(() => {


                                if (!SeInscrito) {
                                    return (
                                        <Button isLoading={processando} cor="continuar" type='button' isCancelar={false} onClick={() => { inscreverProcesso(listaDeProcessoSeletivo.id) }}>
                                            Inscrever-se
                                        </Button>
                                    );
                                }

                                if (dadosInscricao) {
                                    return (
                                        <DivSituacao
                                            texto={dadosInscricao.situacaoCandidatura}
                                            cor={dadosInscricao.situacaoCandidatura.toLowerCase()}
                                        />
                                    );
                                }
                            })()}
                        </>
                    )}
                </section>
                {dadosInscricao?.feedback && <section className="card_detalhe_feedback">
                    <h3 className="subtitulo">Feedback do Recrutador</h3>
                    <p className="descricao">{dadosInscricao?.feedback || "Não houve feedback do recrutador."}</p>
                </section>
                }
                <section className="conteudo_container">
                    <div className="etapas_container">
                        {(listaDeProcessoSeletivo?.processoEtapas ?? []).map((etapa) => {
                            const estaAtiva = etapa.etapa.toLowerCase() === dadosInscricao?.etapaProcesso.toLowerCase();
                            const statusClasse = estaAtiva ? dadosInscricao?.situacaoCandidatura.toLowerCase() : "";
                            return (
                                <div className={`etapa_item ${estaAtiva ? "ativa" : ""} ${statusClasse}`}><span>{etapa.etapa}</span></div>
                            )
                        })}
                    </div>

                    <section className="card_detalhe">
                        <h3 className="subtitulo">Principais atribuições</h3>
                        <div className="container-atribuicoes">
                            {listaDeProcessoSeletivo?.principaisAtribuicao ? (
                                listaDeProcessoSeletivo.principaisAtribuicao.split('\n').map((item, index) => (
                                    item.trim() && (
                                        <span key={index} className="tag-atribuicoes">
                                            {item}
                                        </span>
                                    )
                                ))
                            ) : (
                                <span className="tag-atribuicoes">Atribuições não disponíveis</span>
                            )}
                        </div>
                    </section>

                    <div className="card_detalhe">
                        <p className="subtitulo">Requisitos</p>
                        <div className="container-habilidades">
                            {listaDeProcessoSeletivo?.requisitos ? (
                                listaDeProcessoSeletivo.requisitos.split('\n').map((item, index) => (
                                    item.trim() && (
                                        <span key={index} className="tag-habilidades">
                                            {item}
                                        </span>
                                    )
                                ))
                            ) : (
                                <span className="tag-habilidades">Requisitos não disponíveis</span>
                            )}
                        </div>
                    </div>

                    <div className="card_detalhe">
                        <p className="subtitulo">Diferenciais</p>
                        <div className="container-habilidades">
                            {listaDeProcessoSeletivo?.diferenciais ? (
                                listaDeProcessoSeletivo.diferenciais.split('\n').map((item, index) => (
                                    item.trim() && (
                                        <span key={index} className="tag-habilidades">
                                            {item}
                                        </span>
                                    )
                                ))
                            ) : (
                                <span className="tag-habilidades">Habilidades não disponíveis</span>
                            )}
                        </div>
                    </div>

                    <div className="card_detalhe">
                        <p className="subtitulo">Formação Acadêmica</p>
                        <span className="tag-descricao">{listaDeProcessoSeletivo?.formacaoAcademica || "Formação Acadêmica não disponivel"}</span>
                    </div>

                    <div className="card_detalhe">
                        <h3 className="subtitulo">Benefícios</h3>
                        <div className="container-beneficios">
                            {listaDeProcessoSeletivo?.beneficios ? (
                                listaDeProcessoSeletivo.beneficios.split('\n').map((item, index) => (
                                    item.trim() && (
                                        <p key={index} className="beneficio-item">
                                            {item}
                                        </p>
                                    )
                                ))
                            ) : (
                                <p className="beneficio-item">Benefícios não disponíveis</p>
                            )}
                        </div>
                    </div>

                </section>
                <span className="botoesContainer">
                    {(listaDeProcessoSeletivo?.situacao === "Aguardando Inscritos" || listaDeProcessoSeletivo?.situacao === "Repescagem") && <Button
                        isLoading={processando}
                        onClick={() => handleCopiar(listaDeProcessoSeletivo?.id)}
                        cor="continuar"
                        type="button"
                        isCancelar={false}
                    >
                        {copiado ? "Copiado!" : 'Copiar Link'}
                    </Button>}
                    <Button isLoading={processando} cor="continuar" type='button' isCancelar={false} onClick={fecharModal}>
                        Fechar
                    </Button>
                </span>
            </section>
        </div>
    );
}

export default ModalDetalhesVagas;